/* titanore-desk-ipad-live 20260826-nosticky */
(function () {
  try {
    var p = (location.pathname || '').toLowerCase();
    if (p.indexOf('chefs-pan') === -1) return;
    if (window.__tlDeskIpadApplied) return;
    window.__tlDeskIpadApplied = 1;

    var PREVIEW =
      '//titanorelabs.com/cdn/shop/files/Standard_1.webp?v=1776593847&width=720';

    function restoreSizevis() {
      var vis = document.querySelector('.tgem-configure .tgem-sizevis, [data-tgem-sizevis]');
      if (!vis) return;
      var hit = vis.querySelector('a.tgem-sizevis__hit') || vis;
      /* i18n helpers set textContent on [data-en] links and wipe the pan image */
      hit.removeAttribute('data-en');
      hit.removeAttribute('data-nl');
      if (hit.querySelector('[data-tgem-sizevis-img], img')) return;
      var selected = document.querySelector('.tgem-size.is-selected');
      var src =
        (selected && (selected.getAttribute('data-preview') || selected.getAttribute('data-img'))) ||
        PREVIEW;
      var name =
        (selected && (selected.getAttribute('data-cap-name-en') || selected.getAttribute('data-size'))) ||
        'Medium';
      var dia = (selected && selected.getAttribute('data-cap-dia')) || '28CM';
      hit.innerHTML =
        '<img data-tgem-sizevis-img src="' +
        src +
        '" alt="Chef’s Pan ' +
        name +
        ' ' +
        dia +
        '" width="720" height="720" decoding="async">' +
        '<p class="tgem-sizevis__cap"><span class="tgem-sizevis__name" data-tgem-cap-name data-wg-notranslate translate="no">' +
        name +
        '</span><span class="tgem-sizevis__dia" data-tgem-cap-dia data-wg-notranslate translate="no">' +
        dia +
        '</span></p>';
    }

    /* Own tag — never overwrite #tl-hero-video-behind-override (that re-injected sticky). */
    var style = document.getElementById('tl-desk-ipad-live');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tl-desk-ipad-live';
      document.documentElement.appendChild(style);
    }
    style.setAttribute('data-tl-desk', '20260826-nosticky');
    style.textContent = [
      '@media (min-width:750px) and (max-width:1099px){.titanore-ugc-carousel .tugc-track{display:grid!important;grid-auto-flow:unset!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:16px!important;overflow:visible!important}}',
      '@media (min-width:1100px){.titanore-ugc-carousel .tugc-track{display:grid!important;grid-auto-flow:unset!important;grid-template-columns:repeat(4,minmax(0,1fr))!important;gap:18px!important;overflow:visible!important}.titanore-ugc-carousel .tugc-nav{display:none!important}}'
    ].join('');

    restoreSizevis();
    setTimeout(restoreSizevis, 200);
    setTimeout(restoreSizevis, 800);
    setTimeout(restoreSizevis, 1800);
  } catch (e) {}
})();
